export default __webpack_public_path__ + "static/assets/37f7813489097db8eedcac2f15115406.gif";